export const publicEstimateKeys = {
  quote: (responseId: string) => ['public-estimate', responseId] as const,
  quoteInfoMinimal: (responseId: string) =>
    ['public-estimate', responseId, 'info-minimal'] as const,
}
